export const navItems = [
    {
        id:1,
        name:"Home",
        url:"/"
    },
    {
        id:2,
        name:"about",
        url:"/"
        
    },
    {
        id:3,
        name:"Project",
        url:"/"
    },
    {
        id:4,
        name: "contact",
        url:"/"
    }


]